import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import * as s from './DashboardCard.module.scss'

interface IProps {
  imageIdx: number
}

const DashboardCard: React.FC<IProps> = ({ imageIdx }) => {
  const images = useStaticQuery(imagesQuery)

  return (
    <div className={s.card}>
      <GatsbyImage
        image={
          images.imagesCards.edges[imageIdx].node.childImageSharp
            .gatsbyImageData
        }
        alt={`Dashboard card ${imageIdx}`}
      />
      <div className={s.overlayLayer1} />
      <div className={s.overlayLayer2} />
    </div>
  )
}

export default DashboardCard

const imagesQuery = graphql`
  query {
    imagesCards: allFile(
      filter: { absolutePath: { regex: "/images/home/cards/" } }
      sort: { fields: name }
    ) {
      edges {
        node {
          relativePath
          name
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
      }
    }
  }
`
